import Hero from "./Hero";
import LogoCloud from "./LogoCloud";
import Stats from "./Stats";
import Features from "./Features";
import Testimonials from "./Testimonials";
import Pricing from "./Pricing";
import Faq from "./Faq";
import CtaBand from "./CtaBand";

export default function HuddlePage() {
    return (
        <>
            <Hero />
            <LogoCloud />
            <Features />
            <Stats />
            <Testimonials />
            <Pricing />
            <Faq />
            <CtaBand />
        </>
    );
}
